import { IModelEntity } from '@pit/core';
import { IDtoResourceType } from './dto.resource.type.interface';
import { IDtoUser } from './dto.user.interface';
import { IDtoDepot } from './dto.depot.interface';
import { IDtoMandator } from './dto.mandator.interface';
import { IDtoResourceAttribute } from './dto.resource.attribute.interface';
import { IDtoResourceCheck } from './dto.resource.check.interface';

export enum ResourceState {

    Active = 1,
    NotAvailable = 2,
    ShutDown = 4,
    Deactivated = 8,
    Decommissioned = 16

}

export interface IDtoResource extends IModelEntity {

    code?: string;
    description?: string;
    deviceId?: string;
    resourceId?: string;
    state?: ResourceState;

    capacity?: number;
    numberTour?: string;
    timestampLastUsed?: Date;

    currentResourceCheck?: IDtoResourceCheck;
    depot?: IDtoDepot;
    mandator?: IDtoMandator;
    type?: IDtoResourceType;
    userCurrent?: IDtoUser;
    userMain?: IDtoUser;

    attributes?: IDtoResourceAttribute[];

    getAttributeByKey?: (key: string) => IDtoResourceAttribute;
    getHasAttributes?: () => boolean;
    getHasCheckItems?: () => boolean;
    getHasFaults?: () => boolean;
    getIsAssignableToUser?: () => boolean;

}
